import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';
import { useTableContext } from 'lib/context/TableContext/TableContext';

import { permissions } from 'components/state';
import Popover from 'components/shared/Popovers/Popover/Popover';

import SupervisorSettings from './SupervisorSettings';

const Actions = ({ data }) => {
  const [showSupervisorSettings, setShowSupervisorSettings] = useState(false);
  const { setSelectedItem, setShowModal } = useTableContext();

  const userPermissions = useRecoilValue(permissions);

  const onEditModalToggle = () => {
    setSelectedItem(data);
    setShowModal(true);
  };

  const onSupervisorSettingsToggle = () => {
    setShowSupervisorSettings((prev) => !prev);
  };

  const options = [
    ...(pm(userPermissions, 'member.update')
      ? [{ label: 'Edit', onClick: onEditModalToggle, icon: 'edit-2-mono' }]
      : []),
    ...(pm(userPermissions, 'member.update')
      ? [
          {
            label: 'Make supervisor',
            onClick: onSupervisorSettingsToggle,
            icon: 'user-octagon-mono'
          }
        ]
      : [])
  ];

  return (
    <>
      <div className="flex h-full items-center justify-center">
        <Popover
          className="flex h-full w-full items-center justify-center"
          position="left"
          isFixed
          icon="context-menu-horizontal"
          options={options}
          isBorder={false}
        />
      </div>
      <SupervisorSettings
        member={data}
        showModal={!!showSupervisorSettings}
        hideModal={onSupervisorSettingsToggle}
      />
    </>
  );
};

export default Actions;
